import * as SwitchPrimitive from '@radix-ui/react-switch';
import * as React from 'react';
import { cn } from '@/lib/utils';

/**
 * Switch — mesma anatomia do `Checkbox` (borda + preenchimento no azul da
 * ação quando ligado), só que em trilho/bolinha: usado onde a ação é ligar/
 * desligar algo já existente (uma capability concedida, um toggle de status),
 * não marcar um item de uma lista pra agir em lote depois.
 */
export const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitive.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitive.Root
    ref={ref}
    className={cn(
      'peer inline-flex h-5 w-9 shrink-0 items-center rounded-full border border-border-strong bg-bg-subtle transition-colors duration-fast ease-standard disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-primary data-[state=checked]:bg-primary',
      className,
    )}
    {...props}
  >
    <SwitchPrimitive.Thumb className="pointer-events-none block size-3.5 translate-x-0.5 rounded-full bg-bg-surface shadow-sm transition-transform duration-fast ease-standard data-[state=checked]:translate-x-[18px]" />
  </SwitchPrimitive.Root>
));
Switch.displayName = 'Switch';
